import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { FormattedMessage } from 'react-intl'
import ValentineSiteTakeoverBackground from 'takeovers/valentineTakeover/components/ValentineSiteTakeoverBackground'

const valentineTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'valentine',
  imageId: 'gidua9dchhephstwu3jp',
  primaryColour: '#F84916',
  palette: 'default',
  offerTypes: new Set(['hotel']),
  verticals: new Set(['home', 'hotel']),
  heroSection: {
    title: <FormattedMessage
      id="FkgARevWI5zOKw2ic2NU"
      defaultMessage="Happy Valentine’s Day"
      description="Heading title for Valentine's Day promotional campaign"
    />,
    subtitle: <FormattedMessage
      id="RwMgHS4koDvlo0KMpKzm"
      defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
      description="Subtitle for Valentine's Day campaign with promo code"
      values={{ bold: (chunks) => <b>{chunks}</b> }}
    />,
    verticals: new Set(['home']),
  },
  backgroundElement: ValentineSiteTakeoverBackground,
  offerPage: {
    bannerContent: <FormattedMessage
      id="O9QXzcbJpOCGk6Pg3ToK"
      defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
      description="Offer page banner for Valentine's Day campaign with promo code"
      values={{ bold: (chunks) => <b>{chunks}</b> }}
    />,
  },
  siteWide: {
    banner: {
      description: <FormattedMessage
        id="_p4oz37P2K7UpF_XFOLc"
        defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
        description="Site-wide banner for Valentine's Day campaign with promo code"
        values={{ bold: (chunks) => <b>{chunks}</b> }}
      />,
    },
  },
  searchPage: {
    bannerContent: <VerticalSpacer gap={2}>
      <Heading variant="heading2"><FormattedMessage
        id="gkdBKyB5k6CuvMLHU8xI"
        defaultMessage="Happy Valentine’s Day"
        description="Heading for Valentine's Day campaign on search page"
      />
      </Heading>
      <BodyText variant="large"><FormattedMessage
        id="PHRUmLU0JilRqTycjm98"
        defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
        description="Search page banner for Valentine's Day campaign with promo code"
        values={{ bold: (chunks) => <b>{chunks}</b> }}
      />
      </BodyText>
    </VerticalSpacer>,
  },

}

export default valentineTakeoverConfig
